import { render, staticRenderFns } from "./ContaContabilForm.vue?vue&type=template&id=38c12e40"
import script from "./ContaContabilForm.vue?vue&type=script&lang=js"
export * from "./ContaContabilForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports